import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import {
  addRfxNr,
  getQuotation,
  quotationListInfo,
} from "../../../../redux/feature/supplier_app/sourcingSlice";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";

const VendorQuotationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Quotation");
  let quotationData = useSelector((state) => state?.sourcing?.quotation); // User Details from Store
  let quotationTable = useSelector(
    (state) => state?.sourcing.quotation.pagination
  ); // User Details from Store

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const loadInitialSuuplierData = async () => {
    setData(quotationData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getQuotation(obj));
    setData(quotationData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getQuotation(obj));
    setData(quotationData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getQuotation(obj));
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotationData]);

  const detailedPage = (quotationNr, qtnVersion) => {
    let obj = {
      quotationNr,
      qtnVersion,
    };
    dispatch(quotationListInfo(obj));
    navigate(Constants.SOURCING_QUOTATION_DETAILS);
  };

  const detailedPageBuyer = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(Constants.SOURCING_VENDOR_RFQ_DETAILS);
  };

  const columns = [
    {
      name: "Quotation Nr",
      selector: (row) => row.quotationNr || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.quotationNr, row.qtnVersion)}
        >
          {row.quotationNr || "-"}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Version",
      selector: (row) => row.qtnVersion,
      sortable: true,
      width: "100px",
    },
    {
      name: "Status",

      cell: (row) => (
        <>
          <TableStatusField status={row.quotationStatus} />
        </>
      ),
      width: "130px",
    },
    {
      name: "Qtn Value ",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.qtnTotal).toFixed(2))}
        </span>
      ),
      selector: (row) => row.qtnTotal || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Currency",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">
            {" "}
            {row.qtnBidderCurrency}{" "}
          </span>
        </>
      ),
      selector: (row) => row.qtnBidderCurrency,
      sortable: true,
      width: "160px",
    },
    {
      name: "Date",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "190px",
    },

    {
      name: "RFQ Number",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageBuyer(row.rfxNr)}
        >
          {row.rfxNr}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "RFQ Version",
      selector: (row) => row.rfxVersion || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "RFQ Open Date ",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "RFQ Close Date",
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Revised Closing Date",
      selector: (row) => row.sap_rfq || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "RFQ Category",
      selector: (row) => row.rfxCategoryDesc || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Buyer Responsible",
      selector: (row) => row.buyerResponsible || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "RFQ Type",
      cell: (row) => (
        <>
          <span> {row.rfxTypeDesc} </span>
        </>
      ),
      selector: (row) => row.rfxTypeDesc || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Product Type",
      selector: (row) => row.productType || "--",
      sortable: true,
      width: "180px",
    },

    {
      name: "Submitted By",
      selector: (row) => row.quotationSubmittedBy,
      sortable: true,
      width: "150px",
    },
    {
      name: "Submitted ID",
      selector: (row) => row.qtnSubmittedID,
      sortable: true,
      width: "150px",
    },
    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyAddressDesc} </span>
        </>
      ),
      selector: (row) => row.companyAddressDesc,
      sortable: true,
      width: "130px",
    },
    {
      name: "Plant",
      cell: (row) => (
        <>
          <span> {row.plantDesc} </span>
        </>
      ),
      selector: (row) => row.plantDesc,
      sortable: true,
      width: "140px",
    },
  ];

  const lineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.qtnItem} </span>,
      width: "150px",
    },

    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "150px",
    },
    {
      name: "Brief Description",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "150px",
    },
    {
      name: "RFQ Quantity",
      cell: (row) => <span>{row.rfxQuantity} </span>,
      width: "150px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.rfxQuantityUnit} </span>,
      width: "150px",
    },
    {
      name: "Unit",
      cell: (row) => <span>{row.unitPrice} </span>,
      width: "150px",
    },
    {
      name: "Total",
      cell: (row) => <span>{row.lineTotal} </span>,
      width: "150px",
    },
    {
      name: "IncoTerms",
      cell: (row) => <span>{row.incoTerms} </span>,
      width: "150px",
    },
    {
      name: "IncoTerms Location",
      cell: (row) => <span>{row.incoTermsLocation} </span>,
      width: "150px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Quotation</h2>
                <p className="subText">Lists of Quotation and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QN</span>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                      <span className="headerTitle">Quotation List</span>
                      <span className="subHeaderTitle">
                        View of Quotation and Status
                      </span>
                    </Col>

                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-plus-lg"></i> Change Buyer
                      </button>
                    </Col> */}

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={quotationData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={quotationTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    </main>
  );
};

export default VendorQuotationList;
